import React from "react";
import PuzzlePromotionPanel from "../../pzl_common/stats/PuzzlePromotionPanel";
import StatsSlidingService from "../../../services/StatsSlidingService";

const EMAIL_TYPES = [
    { value: "sliding_puzzle_quest_review", label: "Sliding Puzzle Quest review request" },
];

export default function SlidingPromotionPanel({ language }) {
    return (
        <PuzzlePromotionPanel
            language={language}
            storageKeyPrefix="admin.sliding.promotion"
            fetchUsers={StatsSlidingService.promotionUsers}
            defaultAppId="sliding_puzzle_quest"
            defaultAppName="Sliding Puzzle Quest"
            emailTypes={EMAIL_TYPES}
            emptyLabel="No Sliding Puzzle Quest players."
            description="Signed-in Sliding Puzzle Quest players with play records. Name / Email shows the display name and address separately. Email share: Shared is a personal address, Apple relay is Sign in with Apple Hide My Email (@privaterelay.appleid.com — you can still see that relay address). Sorted by last play (newest first). Select players to send a promotion email. Click a name to open the account."
            dialogHint="Compose and send from Advertisement → Promotion. Create new, then select Sliding Puzzle Quest to load the template. Recipient history is in system_log (source PromotionEmail)."
        />
    );
}
